import React, {useState} from 'react'
import {Image , Icon, Grid , Container, Button} from 'semantic-ui-react';
import {map} from "lodash"
import {GET_PUBLICS} from "../../../gql/publication";
import ModalPubication from '../../ModalPublicasion /ModalPubication';
import Title from '../../ModalUpload/Title/Title';
import { useQuery } from '@apollo/client';
import userAuth from '../../../hooks/useAuth';
import usePublic from '../../../hooks/usePublic';
import ModalBasic from "../../ModalBasic/ModalBasic";
import ModalUpload2 from '../../ModalUpload';
import SetingPublic from "../PreviewPublication./SetingPublic/SetingPublic"


import ActionsVentModal from "../../ModalPublicasion /ActionsVent/ActionsVentModal"
//import Public from '../public/Public';
import "./Preview.scss" 



function Preview(props) {
    const {publication } = props;
    const[showModal,setShowModal] = useState(false);
    const [show, setShow]= useState (false);
    const [titleModal , setTitleModal] = useState("");
    const [childrenModal, setChildrenModal]=  useState(null) ;
    const {auth} = userAuth ();
    const [publit, setPublit]= useState ([])
    const timeAgo = (publication.createAt);
    const date = ( new Date(timeAgo*1)).toLocaleTimeString()
    const date1 = ( new Date(timeAgo*1)).toLocaleDateString()
    


   /* const {data, loading}= useQuery(GET_PUBLICS,{
      variables: {
        idPublication: publication.id,
      }

    });
  
    if (loading) return null;
  
    const {getPublics} = data;

    console.log (publication);


*/
  
 






 
    
    const handlerModal = (type) => {
      switch (type) {
        case "uploadF":
          setTitleModal("Marca el articulo como agotado ");
          setChildrenModal( <ActionsVentModal  publication={publication}   setShowModal={setShowModal}
            setTitleModal = {setTitleModal}
            setChildrenModal ={setChildrenModal} />); 
          setShowModal (true);

          
          break;
           case "publict":
            
            setShow (true);

            break;
            case "delete":
              setTitleModal("Ajustes de la Publicacion ⚙️ ");
              setChildrenModal ( <SetingPublic publication={publication}  setShowModal={setShowModal}
                setTitleModal = {setTitleModal}
                setChildrenModal ={setChildrenModal} />);
              setShowModal (true);


        default:
          break;
          }
        }

       


  return (




    <>

        


          <div  className=' preview_ti'>
          
       
              
                <Grid.Column>
                 <p> {publication.title}</p>
                 
                  </Grid.Column>
                  
               
                

          

    </div>
        
        
        <div className='preview_foto' onClick={(onAction) => handlerModal("publict")}  >

          
            <Image className='preview_i' src={publication.file} />
            
            
            
            <div className='preview_description'>  
               <Grid.Column >
               <Icon name="dollar sign"    />
               <span> {publication.precio} </span> 

                 <p>  {publication.description}</p>

                  </Grid.Column>
              </div>
            


              <div>
          </div>    

      </div>




      <div className='preview_fecha'>
      
        


  {auth.adminis || auth.id === publication.idUser ?  (
<Button  icon = "ban" onClick={() => handlerModal("uploadF")}/>

): (<Icon name = "calendar alternate outline"></Icon>)}

   

<span>  {date1}</span>
          

  {auth.adminis || auth.id === publication.idUser ?  (
<Button icon = "cog" onClick={() => handlerModal("delete")}/>

): (<Icon name = "check square outline"></Icon>)}




</div>

















      <ModalPubication show={show}  setShow= {setShow} publication= {publication}   />   

      <div>
      <ModalBasic show={showModal} setShow={setShowModal} title = {titleModal}>
     {childrenModal}
     </ModalBasic>

      </div>
      
    </>
  )
}


export default Preview